const subnavbarDataforRoute = [
    {to: '/', content: 'HOME'},
    {to: '/categories', content: 'CATEGORIES'},
    // {to: '', content: 'PRODUCTS'},
    {to: '/about-us', content: 'ABOUT US'},
    {to: '/gallery', content: 'GALLERY'},
    {to: '/testimonial', content: 'TESTIMONIALS'},
    {to: '/contact-us', content: 'CONTACT US'},
]
export default subnavbarDataforRoute